var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowUp2 = function SvgArrowUp2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.37495 14.1667V7.34214L7.94185 8.77524C7.69777 9.01932 7.30214 9.01932 7.05806 8.77524C6.81398 8.53117 6.81398 8.13553 7.05806 7.89145L9.55806 5.39145L9.60526 5.34832C9.85074 5.14807 10.213 5.16262 10.4418 5.39145L12.9418 7.89145C13.1859 8.13553 13.1859 8.53117 12.9418 8.77524C12.6978 9.01932 12.3021 9.01932 12.0581 8.77524L10.625 7.34214V14.1667C10.625 14.5119 10.3451 14.7917 9.99995 14.7917C9.65477 14.7917 9.37495 14.5119 9.37495 14.1667Z",
    fill: "currentColor"
  })));
};
export default SvgArrowUp2;